import { render } from "./HomeItsCaseStudiesComp.vue?vue&type=template&id=6a23af11&scoped=true"
import script from "./HomeItsCaseStudiesComp.vue?vue&type=script&lang=js"
export * from "./HomeItsCaseStudiesComp.vue?vue&type=script&lang=js"

import "./HomeItsCaseStudiesComp.vue?vue&type=style&index=0&id=6a23af11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a23af11"]])

export default __exports__